var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportes = function SvgReportes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "reportes_svg__Capa_2",
    viewBox: "0 0 65.36 55.41"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reportes_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.8,
    height: 45.92,
    y: 9.49,
    rx: 3.97,
    ry: 3.97,
    fill: "#f1dffb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.05,
    cy: 18.68,
    r: 2.16,
    fill: "#7f15bc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.66,
    height: 4.32,
    x: 14.89,
    y: 16.52,
    rx: 1.85,
    ry: 1.85,
    fill: "#7f15bc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.65,
    height: 4.32,
    x: 5.89,
    y: 25.2,
    rx: 1.85,
    ry: 1.85,
    fill: "#7f15bc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.65,
    height: 4.32,
    x: 5.89,
    y: 34.67,
    rx: 1.85,
    ry: 1.85,
    fill: "#7f15bc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.53,
    height: 4.32,
    x: 5.89,
    y: 44.02,
    rx: 1.85,
    ry: 1.85,
    fill: "#7f15bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.29 30.22H57.6c5.85 0 9.58-6.23 6.83-11.39L56.58 4.1c-2.95-5.53-10.91-5.45-13.74.14l-7.46 14.73c-2.61 5.15 1.13 11.24 6.91 11.24Z",
    fill: "#ff4772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.19 24.93c-.39-.39-.58-.86-.58-1.41s.19-1.03.58-1.41.86-.58 1.41-.58.99.19 1.37.58.56.86.56 1.41-.19 1.03-.56 1.41c-.37.39-.83.58-1.37.58s-1.03-.19-1.41-.58m2.93-17.35-.29 10.29c-.02.56-.47 1-1.03 1h-.44c-.56 0-1.02-.44-1.03-1l-.3-10.29c-.02-.58.45-1.06 1.03-1.06h1.02c.58 0 1.05.48 1.03 1.06Z",
    fill: "#fff"
  }))));
};
export default SvgReportes;